import { useState } from "react";
import { format } from "date-fns";
import { encodeQueryParams } from "../../../../../utils/EncodeDecodeQueryParams";

export const useAPIGetDelListData = (props) => {
  const {
    uiContext,
    navigate,
    location,
    requestGet,
    requestDelete,
    loading,
    filterValue,
  } = props;

  const [paging, setPaging] = useState({
    page: 1,
    take: 20,
    filter: "",
    total: 0,
  });
  const [listData, setListData] = useState([]);

  //  API call section

  const fetchListData = async ({
    page,
    take,
    filter,
    filterValue: _filterValue,
  }) => {
    if (loading) return;

    const _filter =
      (filter ?? getFilter(_filterValue)) +
      `;tanggal_transaksi:!=:Null;data_kendaraan.data_kendaraan_jenis.nama:=:Trado`;

    return requestGet({
      fullUrl: `/api/pemakaian/pemakaianmobil/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: "tanggal_transaksi",
        order_method: "DESC",
        with_pemakai: 1,
        with_kendaraan: 1,
        with_trailer_berangkat: 1,
        with_trailer_pulang: 1,
        with_supir: 1,
        with_supir_pulang: 1,
        with_tujuan: 1,
      },
      onSuccess: async ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListData(data.map((item, index) => ({ ...item, no: index + 1 })));

        const urlFilter = _filterValue
          ? { ..._filterValue }
          : { ...filterValue };
        urlFilter.page = paging.page;
        urlFilter.take = paging.take;
        const encodedUrlFilter = await encodeQueryParams(
          JSON.stringify(urlFilter)
        );
        navigate(`${location.pathname}?key=${encodedUrlFilter}`, {
          replace: true,
        });
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async (id) => {
    return await requestDelete({
      fullUrl: "/api/pemakaian/pemakaianmobil/delete",
      ids: [id],
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ message, data }) => {
        uiContext.showSuccessMsg("Success", message);

        // remove data from listData
        const newListData = listData.filter((item) => item.id !== id);
        setListData(newListData);
      },
    });
  };

  // other function section

  // const getEncodedQueryParams = async ({
  //   page,
  //   take,
  //   filterText,
  //   filterObject,
  // }) => {
  //   let filterKendaraan = null;
  //   if (filterObject.kendaraan) {
  //     filterKendaraan = {
  //       id: filterObject.kendaraan.id,
  //       nomor_polisi: filterObject.kendaraan.nomor_polisi,
  //       merek: filterObject.kendaraan.merek,
  //     };
  //   }
  //   const queryParamsText = `filter=${filterText}${
  //     filterKendaraan
  //       ? `|||kendaraan_id=${JSON.stringify(filterKendaraan)}`
  //       : ""
  //   }&page=${page}&take=${take}`;
  //   const encodedQueryParams = await encodeQueryParams(queryParamsText);
  //   return encodedQueryParams;
  // };

  const getFilter = (filterValueInput) => {
    const filters = [];

    const _filterValue = filterValueInput ?? filterValue;

    let filterDate = "";
    if (filterValue.dari) {
      filterDate += `tanggal_transaksi:>=:${format(
        _filterValue.dari,
        "yyyy-MM-dd"
      )} 00:00:00`;
    }

    if (_filterValue.sampai) {
      if (filterDate.length > 0) filterDate += ";";
      filterDate += `tanggal_transaksi:<=:${format(
        _filterValue.sampai,
        "yyyy-MM-dd"
      )} 23:59:59`;
    }

    if (filterDate !== "") {
      if (filterDate.includes(";")) {
        filterDate =
          filterDate.replaceAll(";", `||tanggal_pulang:=:Null;`) +
          `||tanggal_pulang:=:Null`;
      }
      filters.push(filterDate);
    }

    if (_filterValue.data_kendaraan && _filterValue.data_kendaraan.id > 0) {
      filters.push(`kendaraan_id:=:${_filterValue.data_kendaraan.id}`);
    }

    // filters.push("tanggal_pulang:!=:Null");

    return filters.join(";");
  };

  // const getFilterDiProses = () => {
  //   const filters = [];

  //   // const filterDate = convertDateRangeToAPIFilter({
  //   //   field: "tanggal_transaksi",
  //   //   value: filterValue.tanggal_transaksi,
  //   // });
  //   // if (filterDate !== "") filters.push(filterDate);

  //   filters.push("tanggal_pulang:=:Null");

  //   const filterKendaraan = convertObjectToAPIFilter({
  //     field: "kendaraan_id",
  //     value: filterValue.kendaraan,
  //     valueField: "id",
  //   });
  //   if (filterKendaraan !== "") filters.push(filterKendaraan);

  //   return filters.join(";");
  // };

  return {
    paging,
    setPaging,
    listData,
    fetchListData,
    deleteData,
    getFilter,
  };
};
